import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private ff: AngularFireFunctions) { }

  //disparador de emails
  async sendStandardEmail(send_email: any) {

    const mailOptions = {
      html: send_email.html,
      subject: send_email.subject,
      to: send_email.to,
      from: send_email.from,
      bcc: send_email.bcc
    }

    const sendStandardEmail = this.ff.httpsCallable('sendStandardEmail_v1');
    return firstValueFrom(sendStandardEmail(mailOptions));

  }

  sendEmailOrderConfirmation(order: any, product: any) {

    let html: any = this.createEmailOrderConfirmation(order)

    const emailData = {
      "to": order.member_email,
      "subject": "SBCCV - Inscrição Confirmada",
      "html": html
    }

    const sendMailConfirm = this.ff.httpsCallable('sendMail');
    return sendMailConfirm(emailData).subscribe((res) => {
        console.log("res: " + JSON.stringify(res))
      })
  }

  createEmailOrderConfirmation(product) {

    let html: any = ""

    html += "<div>"

    html += "   <div style='font-size:18px;margin:10px 10px 0 10px; padding:10px 10px 0 10px;'>"
    html += "SBCCV - Sociedade Brasileira de Cirurgia Cardiovascular"
    html += "   </div>"

    html += "  <div style='font-size:17px;margin:0 10px 10px 10px; padding:10px;'>"
    html += "Agradecemos sua inscrição"
    html += "   </div>"

    html += "   <div style='width:400px; color:rgba(0,0,0,.8); margin:10px; padding:10px; background-color:rgba(100,100,100, .1); '>"
    //html +=       product.text
    html += '<p><strong>Curso de Atualização • 2020</strong><br/>6 a 8 de Fevereiro de 2020</p><p><b>Dr. Henrique Murad</b><br/>Diretor de Educação SBCCV</p><p><b>Tryp Paulista</b><br/>Rua: Haddock Lobo, 294<br/>Cerqueira César<br/>São Paulo / Brasil</p><p>http://www.sbccv.org.br<br/>sandra@sbccv.org.br</p>'
    html += "   </div>"

    html += "</div>"

    return html

  }

}
